import { toast } from 'react-toastify'

const CART_STORAGE_KEY = 'shopping_cart'

const addToCart = async(e, data) => {
    e?.stopPropagation()
    e?.preventDefault()
    
    // Proper way to log objects in JavaScript
    console.log("Product data:", data)
    console.log("Product ID:", data._id)
    console.log("Product Name:", data.productName)
    console.log("Full product details:", JSON.stringify(data, null, 2))
    
    try {
        // Get existing cart from localStorage
        const existingCart = localStorage.getItem(CART_STORAGE_KEY)
        let cart = existingCart ? JSON.parse(existingCart) : []

        // Check if product already exists in cart
        const existingProductIndex = cart.findIndex(item => item.productId === data._id)

        if (existingProductIndex !== -1) {
            // Product exists, increase quantity
            cart[existingProductIndex].quantity += 1
            toast.success('Product quantity updated in cart')
        } else {
            // Add new product to cart with full product data
            cart.push({
                productId: data._id,
                productName: data.productName,
                productImage: data.productImage,
                category: data.category,
                price: data.price,
                sellingPrice: data.sellingPrice,
                quantity: 1,
                addedAt: new Date().toISOString()
            })
            toast.success('Product added to cart')
        }

        // Save updated cart to localStorage
        localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart))
        
        console.log("Updated cart:", cart)

        return {
            success: true,
            message: existingProductIndex !== -1 ? 'Product quantity updated' : 'Product added to cart',
            data: cart
        }

    } catch (error) {
        console.error('Error adding to cart:', error)
        toast.error('Failed to add product to cart')
        
        return {
            success: false,
            error: true,
            message: 'Failed to add product to cart'
        }
    }
}

// Helper function to get cart from localStorage
export const getCart = () => {
    try {
        const cart = localStorage.getItem(CART_STORAGE_KEY)
        return cart ? JSON.parse(cart) : []
    } catch (error) {
        console.error('Error getting cart:', error)
        return []
    }
}

// Helper function to get cart count
export const getCartCount = () => {
    try {
        const cart = getCart()
        return cart.reduce((total, item) => total + item.quantity, 0)
    } catch (error) {
        console.error('Error getting cart count:', error)
        return 0
    }
}

// Helper function to remove item from cart
export const removeFromCart = (productId) => {
    try {
        const cart = getCart()
        const updatedCart = cart.filter(item => item.productId !== productId)
        localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(updatedCart))
        toast.success('Product removed from cart')
        return {
            success: true,
            data: updatedCart
        }
    } catch (error) {
        console.error('Error removing from cart:', error)
        toast.error('Failed to remove product from cart')
        return {
            success: false,
            error: true
        }
    }
}

// Helper function to update quantity
export const updateCartQuantity = (productId, quantity) => {
    try {
        const cart = getCart()
        const productIndex = cart.findIndex(item => item.productId === productId)
        
        if (productIndex !== -1) {
            if (quantity <= 0) {
                // Remove item if quantity is 0 or less
                return removeFromCart(productId)
            }
            
            cart[productIndex].quantity = quantity
            localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart))
            toast.success('Cart updated')
            
            return {
                success: true,
                data: cart
            }
        }
        
        return {
            success: false,
            error: true,
            message: 'Product not found in cart'
        }
    } catch (error) {
        console.error('Error updating cart quantity:', error)
        toast.error('Failed to update cart')
        return {
            success: false,
            error: true
        }
    }
}

// Helper function to clear entire cart
export const clearCart = () => {
    try {
        localStorage.removeItem(CART_STORAGE_KEY)
        toast.success('Cart cleared')
        return {
            success: true,
            data: []
        }
    } catch (error) {
        console.error('Error clearing cart:', error)
        toast.error('Failed to clear cart')
        return {
            success: false,
            error: true
        }
    }
}

export default addToCart